import React from 'react';
import { useVariableNode } from './Variable.tsx';

export function Conditional({ condition, trueContent, falseContent }) {
    const conditionVal   = useVariableNode(condition);
    return (conditionVal) ? trueContent : falseContent;
}